// Returning "home" needs to force a real reset even when we're already on
// '/' — react-router's navigate('/') is a no-op when the path doesn't
// change, so any client-only view state (e.g. PassengerSearchPage's
// selected service tab collapsing the page to just the trip search) stays
// stuck.
//
// A hard window.location.href reload used to be the fix here, but that
// breaks an installed PWA out of standalone mode (the browser address bar
// reappears) — a full navigation forces the OS/browser to re-evaluate the
// page from scratch instead of staying inside the app shell. Broadcasting
// this event instead lets PassengerSearchPage reset its own state in
// place (via a key remount), with zero navigation involved.
export const goHome = (navigate, pathname) => {
  if (pathname === '/') {
    window.dispatchEvent(new Event('safer:go-home'));
  } else {
    navigate('/');
  }
};
